// extracted by mini-css-extract-plugin
module.exports = {"detail":"Detail_detail__73PlZ","detail__label":"Detail_detail__label__1hmtz","detail__value":"Detail_detail__value__BK9c7"};